import { ListingConfigTransport } from '../../transports/property-details-page-transport'

export class ListingConfigModel {
    private _isContactInformationRequired: ListingConfigTransport['isContactInformationRequired']

    constructor(data: ListingConfigTransport) {
        this._isContactInformationRequired = data?.isContactInformationRequired ?? false
    }

    // Getters
    public get isContactInformationRequired(): ListingConfigTransport['isContactInformationRequired'] {
        return this._isContactInformationRequired
    }
}
